var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"fab":"","rounded":"","small":"","plain":""},on:{"click":_vm.fullScreen}},[_c('v-icon',[_vm._v(_vm._s(!_vm.pageStore.isFullScreen ? _vm.icons.mdiFullscreen : _vm.icons.mdiFullscreenExit))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }